// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"FileDownloadButton_downloadButton__26bDA"};